import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    conversationId: null,
    conversations: [],
    lastMessageId: null
};

const conversationsSlice = createSlice({
    name: 'conversations',
    initialState,
    reducers: {
        setConversationId: (state, action) => {
            state.conversationId = action.payload;
        },
        setConversations: (state, action) => {
            state.conversations = action.payload;
        },
        removeConversation: (state, action) => {
            state.conversations = state.conversations.filter(c => c.id !== action.payload);
        },
        updateConversationTitle: (state, action) => {
            const { id, title } = action.payload;
            const conv = state.conversations.find(c => c.id === id);
            if (conv) conv.title = title;
        },
        setLastMessageId: (state, action) => {
            state.lastMessageId = action.payload;
        },
        resetConversation: (state) => {
            state.conversationId = null;
            state.lastMessageId = null;
        }
    }
});

export const {
    setConversationId,
    setConversations,
    removeConversation,
    updateConversationTitle,
    setLastMessageId,
    resetConversation
} = conversationsSlice.actions;

export default conversationsSlice.reducer;
